// extracted by mini-css-extract-plugin
export default {"wrap":"SearchInput_wrap_zHKrS","icon":"SearchInput_icon_pCoqY","input":"SearchInput_input_I6z_G","clear":"SearchInput_clear_qJijQ"};